module.exports = __webpack_public_path__ + "img/appstore.1d15e716.png";